import styled from "@emotion/styled";

export const alertContainer = styled.div`
  padding: 12px 16px 12px 20px;
  border: 1px solid #d6d8d9;
  background: #ecf8ff;
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const alertDivider = styled.div`
  width: 7px;
  height: 100%;
  background: #047bbc;
  position: absolute;
  left: 0;
  top: 0;
`;

interface TextProps {
  size?: string | number;
  color?: string;
  weight?: string | number;
}

export const Text = styled.div<TextProps>`
  font-size: ${props => props.size || "14px"};
  color: ${props => props.color || "#000"};
  font-weight: ${props => props.weight || "400"};
`;

export const FlexJustifyBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
